import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderSlot as _renderSlot, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import "./AdditionalLayout.scss";
import Footer from "@/components/Footer/Footer.vue";
import Menu from "@/components/Menu/Menu.vue";
import Header from "@/components/Header/Header.vue";

interface Props{
	title : string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AdditionalLayout',
  props: {
    title: {}
  },
  setup(__props: any) {

let props = __props;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Header, {
      back: "",
      title: _unref(props).title
    }, null, 8, ["title"]),
    _renderSlot(_ctx.$slots, "default"),
    _createVNode(Footer),
    _createVNode(Menu)
  ], 64))
}
}

})